import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-drop-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">爱威奶在线</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              爱威奶官方正品购买平台，汇聚全系列产品，支持在线下单、快速配送、售后保障，让您足不出户享受品质服务。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-foreground-300 hover:text-background-50" aria-label="微信">
                <i className="ri-wechat-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-foreground-300 hover:text-background-50" aria-label="微博">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors text-foreground-300 hover:text-background-50" aria-label="抖音">
                <i className="ri-tiktok-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">
              <a href="/category" className="hover:text-primary-400 transition-colors">产品分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/chun-niu-nai" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">纯牛奶系列</Link></li>
              <li><Link to="/category/suan-nai" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">酸奶系列</Link></li>
              <li><Link to="/category/er-tong-niu-nai" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">儿童牛奶系列</Link></li>
              <li><Link to="/category/gao-gai-nai" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">高钙奶系列</Link></li>
              <li><Link to="/category/di-zhi-niu-nai" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">低脂牛奶系列</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">
              <a href="/articles" className="hover:text-primary-400 transition-colors">文章资讯</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="/articles" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">营养知识</a></li>
              <li><a href="/articles" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">优惠活动</a></li>
              <li><a href="/articles" className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors">品牌新闻</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4 font-heading">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-400">服务热线：400-888-9999</span></li>
              <li><span className="text-sm text-foreground-400">工作时间：9:00 - 21:00</span></li>
              <li><span className="text-sm text-foreground-400">邮箱：service@aiweinai.com</span></li>
              <li><span className="text-sm text-foreground-400">地址：内蒙古呼和浩特市乳业园区</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 爱威奶在线 版权所有 | 内蒙古爱威奶乳业有限公司
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">ICP备案号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}